
import {defineComponent} from 'vue'

export default defineComponent({
    name: "CardContentSeparator",
    props: {
        iconClass: {
            type: String,
            required: true,
        }
    },
})
